<template>
    <div
        class="official-dynamic pb-show-display"
        :class="{
            'official-dynamic-first' : !showIdx,
            'bg-color': isDynamicTab,
            'no-margin': isDynamicTab && !showIdx
        }"
        :data-pblog="pblogData"
        @click.stop="goOfficialDynamicDetail"
    >
        <div class="game-msg">
            <img
                :src="gameIcon"
                class="game-icon"
            >
            <div class="msg-r">
                <div class="msg-top">
                    <div class="game-name">{{ appName }}</div>
                    <img v-if="officialJoined" class="official-join-icon" :src="pics[3]" alt="">
                </div>
                <div class="msg-btm">
                    <div class="publick-time">{{ publishTime }}丨</div>
                    <div class="follow-num">{{ followNumShow || 0 }}人关注</div>
                </div>
            </div>
        </div>
        <div
            class="official-dynamic-con"
        >
            <div class="tit">
                <div
                    class="tag"
                    :class="{'top-tag': officialNewsPost.is_top}"
                >
                    {{ officialNewsPost.is_top ? '置顶' : officialNewsPost.tag }}
                </div>
                <div class="title clamp-content-1">{{ officialNewsPost.title }}</div>
            </div>
            <div class="con clamp-content clamp-content-5">
                {{ officialNewsPost.summary }}
            </div>
            <div
                v-if="officialNewsPost.poster_list.length > 0"
                class="imgs"
                :class="{
                    'show-dynamic-img-s': showDynamicImgS
                }"
            >
                <div
                    v-for="(item, idx) in officialNewsPost.poster_list.slice(0,9)"
                    :key="idx"
                    v-lazy:background-image="item.url"
                    class="dynamic-img"
                    :class="{
                        'show-dynamic-img-h': showDynamicImgH
                    }"
                    :style="{backgroundSize:'cover',backgroundRepeat:'no-repeat'}"
                    @click.stop="previewImages(idx)"
                >
                </div>
                <div v-if="otherDynamicImgNum" class="mantle" @click.stop="previewImages(8)">{{ '+' + otherDynamicImgNum }}</div>
            </div>
            <div
                v-if="hasComment"
                class="dynamic-comments"
                :class="{'com-bg-color': isDynamicTab}"
            >
                <div class="publisher">
                    <span class="publisher-name">{{ officialNewsPost.hot_comment.list[0].uname }}：</span>
                    {{ officialNewsPost.hot_comment.list[0].content }}
                </div>
                <div
                    class="go-comment"
                    @click.stop="goOfficialDynamicDetail(1)"
                >
                    <div class="all-num">
                        查看全部{{ hasMoreComment ? commentNum + '条' : '' }}评论
                    </div>
                    <img class="arrow-right" :src="pics[5]" alt="">
                </div>
            </div>
            <div class="dynamic-msg">
                <div class="dynamic-look dynamic-item">
                    <img class="look-icon" :src="pics[4]" alt="">
                    <div class="look-num">{{ officialNewsPost.pv_show || 0 }}</div>
                </div>
                <div
                    class="dynamic-comment dynamic-item"
                    @click.stop="goOfficialDynamicDetail(1)"
                >
                    <img class="comment-icon" :src="pics[0]" alt="">
                    <div class="comment-num">{{ commentNum!==0?commentNum:'评论' }}</div>
                </div>
                <div
                    class="dynamic-praise dynamic-item"
                    @click.stop="noJump"
                >
                    <img class="praise-icon" :src="pics[1]" alt="">
                    <div class="praise-num">
                        {{ likeNum || '抢首赞' }}
                    </div>
                </div>
            </div>
            <div v-if="showPreview" class="preview-wrapper" @click.stop="catchMethods">
                <image-preview
                    :image-index="imageIndex"
                    :image-list="imageList"
                    @close="closePreview"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { getTimeStr, getDeepValue} from '@/utils/utility';
    import { getUrlParams, getQueryString } from '@/utils/url';
    import ImagePreview from '@/components/ImagePreview'
    import comment from 'public/assets/imgs/dynamic-comment.png';
    import like from 'public/assets/imgs/dynamic-like.png';
    import right from 'public/assets/imgs/arrow-gray-right-s.png';
    import officialJoinIcon from 'public/assets/imgs/ic_official_join.png';
    import Look from 'public/assets/imgs/dynamic-look.png';
    import lookMore from 'public/assets/imgs/ic_look_more_blue.png';
    export default {
        components: {
            ImagePreview
        },
        props: {
            officialJoined: {
                type: Boolean,
                required: false
            },
            officialNewsPost: {
                type: Object,
                default: () => ({})
            },
            appName: {
                type: String,
                default: ''
            },
            gameIcon: {
                type: String,
                default: ''
            },
            showIdx: {
                type: Number,
                default: 0
            },
            showTimeAxis: {
                type: Boolean,
                default: false
            },
            isDynamicTab: {
                type: Boolean,
                default: false
            },
            followNumShow: {
                type: String,
                default: '0'
            }
        },
        data() {
            return {
                showDynamicImgS: false,
                showDynamicImgH: false,
                commentNum: 0,
                otherDynamicImgNum: 0,
                hasMoreComment: false,
                hasComment: false,
                pics: [comment, like, right, officialJoinIcon, Look, lookMore],
                appId: '',
                channelid: '',
                moduleName: {
                    moduleName: '动态'
                },
                tagName: {
                    tagName: this.officialNewsPost.tag
                },
                followNum: '',
                imageIndex:0,
                imageList:[],
                showPreview: false,
                pblogData: {}
            }
        },
        computed: {
            publishTime() {
                return getTimeStr(this.officialNewsPost.publish_time);
            },
            likeNum() {
                return this.officialNewsPost.like_num > 9999 ? (this.officialNewsPost.like_num / 10000).toFixed(1) + '万' : this.officialNewsPost.like_num;
            }
        },
        created() {
            this.initDynamicImg();
            this.checkHasComment();
            this.query();
            this.setDisplayLogItem();
        },
        methods: {
            catchMethods() {
                return;
            },
            query() {
                const { appId, channelid} = getUrlParams();
                this.appId = appId;
                this.channelid = channelid;
            },
            initDynamicImg() {
                if (this.officialNewsPost.poster_list && this.officialNewsPost.poster_list instanceof Array) {
                    if (this.officialNewsPost.poster_list.length === 2 || this.officialNewsPost.poster_list.length === 4) {
                        this.showDynamicImgS = true;
                    }
                    if (this.officialNewsPost.poster_list.length >= 9) {
                        this.otherDynamicImgNum = this.officialNewsPost.poster_list.length - 9;
                    }
                    if (this.officialNewsPost.poster_list.length !== 1 ) {
                        this.showDynamicImgH = true;
                    }
                }
            },
            checkHasComment() {
                const hasComment = getDeepValue(this.officialNewsPost, 'hot_comment.comment_count') || 0;
                if (hasComment && +hasComment > 0) {
                    const commentNum = +hasComment;
                    this.commentNum = commentNum > 9999 ? (commentNum / 10000).toFixed(1) + '万' : commentNum;
                    this.hasMoreComment = commentNum > 1;
                    this.hasComment = true;
                }
            },
            goOfficialDynamicDetail(needAnchor) {
                this.$emit('goOfficialDynamicDetail');
                this.doClickLog();
                // 去详情页
                const from = getQueryString('from');
                const srcid = getQueryString('srcid');

                const url = `http://${location.host}/static/game/zone-news.html`;
                const hashRoute = '#/detail';
                const params = {
                    appId: this.appId,
                    channelid: this.channelid,
                    from,
                    srcid,
                }
                const hashParams = {
                    tag: this.officialNewsPost.tag,
                    rid: this.officialNewsPost.rid,
                };
                (needAnchor === 1) && (hashParams.anchor2Cmt = 1);
                window.location.href = `${url}?${this.obj2Query(params)}${hashRoute}?${this.obj2Query(hashParams)}`;
            },
            obj2Query(obj) {
                return Object.keys(obj).reduce((querystring, key) => {
                    const aQs = obj[key] ? `&${key}=${obj[key]}` : '';
                    return querystring += aQs;
                }, '');
            },
            setDisplayLogItem() {
                this.pblogData = JSON.stringify({
                    value: 'dynamicCard',
                    ext: {
                        item: [
                            {
                                id: '',
                                ext: {
                                    moduleName: this.moduleName,
                                    tagName: this.tagName,
                                    dynamicId: this.officialNewsPost.rid,
                                    dynamicPos: this.isDynamicTab ? '动态tab' : '详情tab',
                                    ...this.$root.extData
                                },
                                pos: this.showIdx + 1 || ''
                            }
                        ]
                    }
                });
            },
            doClickLog() {
                this.$logger.click(JSON.parse(this.pblogData));
            },
            previewImages(imageIndex) {
                this.imageIndex = imageIndex;
                this.imageList = this.officialNewsPost.poster_list;
                this.showPreview = true;
            },
            closePreview() {
                this.showPreview = false;
            },
            noJump(){
                return
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .official-dynamic {
        background: #F8F8F8;
        border-radius: px2rem(36);
        padding: 0 px2rem(39);
        margin: px2rem(30) 0 0;
        .game-msg {
            display: flex;
            padding: px2rem(44) 0 0;
            .game-icon {
                width: px2rem(129);
                height: px2rem(129);
                border-radius: 50%;
                margin-right: px2rem(24);
            }
            .msg-r {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: space-between;
                padding: px2rem(14) 0 px2rem(4);
                .msg-top {
                    display: flex;
                    .game-name {
                        color: #1F1F1F;
                        font-weight: 500;
                        margin-right: px2rem(15);
                        font-size: px2rem(48);
                        line-height: px2rem(48);
                        font-weight: 500;
                    }
                    .official-join-icon {
                        width: px2rem(44);
                        height: px2rem(39);
                    }
                }
                .msg-btm {
                    display: flex;
                    font-size: px2rem(39);
                    color: #858585;
                    line-height: px2rem(39);
                    font-weight: 400;
                }
            }
        }
        .official-dynamic-con {
            .tit {
                padding-top: px2rem(19);
                display: flex;
                align-items: center;
                .tag {
                    background: rgba(78,110,242,0.10);
                    border: px2rem(2) solid rgba(78,110,242,0.50);
                    border-radius: px2rem(24);
                    font-size: px2rem(30);
                    color: #4E6EF2;
                    line-height: px2rem(30);
                    margin-right: px2rem(18);
                    padding: px2rem(6) px2rem(15);
                    &.top-tag {
                        background: rgba(255,66,103,0.10);
                        border: px2rem(2) solid #FF4267;
                        color: #FF4267;
                    }
                }
                .title {
                    font-size: px2rem(51);
                    color: #1F1F1F;
                    line-height: px2rem(97);
                    font-weight: bolder;
                    max-width: px2rem(900);
                }
            }
            .con {
                font-size: px2rem(48);
                color: #1F1F1F;
                line-height: px2rem(75);
                font-weight: 400;
            }
            .imgs {
                padding-top: px2rem(12);
                display: flex;
                align-items: center;
                justify-content: flex-start;
                flex-wrap: wrap;
                position: relative;
                width: px2rem(1128);
                &.show-dynamic-img-s {
                    width: px2rem(752);
                }
                .dynamic-img {
                    border-radius: px2rem(36);
                    width: px2rem(728);
                    height: px2rem(480);
                    margin-right: px2rem(24);
                    margin-top: px2rem(24);
                    background-position: center;
                    background-size: cover;
                    &.show-dynamic-img-h {
                        width: px2rem(352);
                        height: px2rem(352);
                        background-size: cover;
                    }
                }
                .mantle {
                    width: px2rem(352);
                    height: px2rem(353);
                    line-height: px2rem(353);
                    text-align: center;
                    position: absolute;
                    top: px2rem(788);
                    right: px2rem(24);
                    border-radius: px2rem(36);
                    background-color: rgba(0,0,0,0.4);
                    color: #fff;
                    font-size: px2rem(72);
                    font-weight: 500;
                }
            }
            .dynamic-msg {
                font-size: px2rem(39);
                line-height: px2rem(39);
                color: #555555;
                font-weight: 400;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: px2rem(48) 0;
                margin: 0 px2rem(-39);
                .dynamic-look {
                    display: flex;
                    align-items: center;
                    width: px2rem(394);
                    justify-content: center;
                    .look-icon {
                        margin-right: px2rem(9);
                        width: px2rem(66);
                        height: px2rem(66);
                    }
                }
                .dynamic-comment {
                    display: flex;
                    align-items: center;
                    width: px2rem(394);
                    justify-content: center;
                    .comment-icon {
                        width: px2rem(66);
                        height: px2rem(66);
                        margin-right: px2rem(9);
                    }
                }
                .dynamic-praise {
                    display: flex;
                    align-items: center;
                    width: px2rem(394);
                    justify-content: center;
                    color: #555555;
                    .praise-icon {
                        width: px2rem(66);
                        height: px2rem(66);
                        margin-right: px2rem(9);
                    }
                }
            }
        }
        .dynamic-comments {
            background: #F3F3F3;
            border-radius: px2rem(27);
            padding: 0 px2rem(39);
            margin-top: px2rem(36);
            .publisher {
                padding-top: px2rem(28);
                font-size: px2rem(42);
                text-align: justify;
                color: #525252;
                line-height: px2rem(52);
                word-break: break-word;
                .publisher-name {
                    color: #1F1F1F;
                    font-weight: 500;
                    flex-shrink: 0;
                    display: inline-block;
                }
            }
            .go-comment {
                padding: px2rem(26) 0 px2rem(39) 0;
                font-size: px2rem(42);
                color: #858585;
                text-align: justify;
                line-height: px2rem(42);
                display: flex;
                align-items: center;
                color: #3388FF;
                .arrow-right {
                    margin-left: px2rem(15);
                }
            }
            &.com-bg-color {
                background-color: #f8f8f8;
            }
        }
        .preview-wrapper {
            z-index: 1500;
            position: fixed;
            width: 100vw;
            height: 100vh;
            .top {
                z-index: 9999;
            }
            .middle {
                height: 100vh !important;
                overflow: scroll;
                display: flex;
                align-items: center;
                .arrow-icon {
                    position: fixed;
                    
                }
                img {
                    height: auto !important;
                }
            }
        }
    }
    .clamp-content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
    }
    .clamp-content-1 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .clamp-content-5 {
        -webkit-line-clamp: 5;
    }
    .official-dynamic-first {
        margin-top: px2rem(36);
    }
    .bg-color {
        background-color: #fff;
    }
    .no-margin {
        margin-top: 0;
    }
</style>